import React from 'react'
import { ControlledTextInput } from 'transfix-form/components'
import { ModalBase, IModalBaseProps, MODAL_TYPES } from 'transfix-ui/components/Modals'
import { Box, makeStyles } from 'transfix-ui/core'
import { ITransactionSetWithSubtype } from 'types/graphqlTypes'
import { useConfigurableBuilderOptionsForm } from '../hooks/useConfigurableBuilderOptionsForm'
import { IConfigurableBuilderOptionsSchema } from '../schema/ConfigurableBuilderOptionsSchema'

interface IConfigurableBuilderOptionsModalProps extends Omit<IModalBaseProps, 'modalType'> {
  options: IConfigurableBuilderOptionsSchema
  onCancel: () => void
  onSubmit: (options: IConfigurableBuilderOptionsSchema) => void
  transactionSetWithSubtype: ITransactionSetWithSubtype
}

const useConfigurableBuilderModalStyles = makeStyles({
  body: {},
  modal: {},
  header: {},
  title: {},
  root: {},
})

export const ConfigurableBuilderOptionsModal = ({
  onCancel,
  onSubmit,
  open = true,
  options,
  ...props
}: IConfigurableBuilderOptionsModalProps) => {
  const methods = useConfigurableBuilderOptionsForm()
  const { control, errors, handleSubmit } = methods

  const submitHandler = handleSubmit((formParams: IConfigurableBuilderOptionsSchema) => {
    onSubmit(formParams)
    onCancel()
  })

  const actions: IModalBaseProps['actions'] = [
    {
      label: 'Cancel',
      action: () => {
        onCancel()
      },
      type: 'dismiss',
      dataTest: 'cancel-button',
    },
    {
      label: 'Save',
      action: submitHandler,
      type: 'confirm',
      dataTest: 'confirm-button',
    },
  ]

  const classes = useConfigurableBuilderModalStyles()

  return (
    <ModalBase
      dataTest='ConfigurableBuilderOptionsModal'
      modalType={MODAL_TYPES.form}
      size={4}
      open={open}
      actions={actions}
      className={classes.root}
      bodyClassName={classes.body}
      titleClass={classes.title}
      modalClassName={classes.modal}
      headerClassName={classes.header}
      title='Configurable Builder Options'
      {...props}>
      <Box mb={2}>
        <ControlledTextInput
          control={control}
          name='outboundEdiMapperConnectionConfigId'
          defaultValue={options.outboundEdiMapperConnectionConfigId}
          TextInputProps={{
            label: 'Outbound EDI Mapper Connection Config ID',
            required: true,
            large: true,
            validationMessage: errors?.outboundEdiMapperConnectionConfigId?.message,
            error: !!errors?.outboundEdiMapperConnectionConfigId?.message,
          }}
        />
      </Box>
    </ModalBase>
  )
}
